import React from "react";
import { FaBullseye, FaLightbulb, FaUsers, FaLeaf, FaChartLine, FaGraduationCap, FaMobileAlt, FaSeedling } from "react-icons/fa";
import "./About.css";

const About = () => {
  
  const heroImage = "https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80";
  

  return (
    <div className="vero-about">
      {/* Hero Section with Image */}
      <section 
        className="vero-about__hero"
        style={{
          backgroundImage: `url(${heroImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="vero-about__hero-overlay"></div>
        <div className="vero-about__hero-content">
          <h1 className="vero-about__hero-title">About Us</h1>
          
        </div>
      </section>

      <div className="vero-about__container">
        {/* Company Overview */}
        <section className="vero-about__section">
          <div className="vero-about__intro">
            <h2 className="vero-about__section-title">About Vero Disruptors</h2>
            <p className="vero-about__lead">
              At Vero Disruptors, we are a forward-thinking startup committed to revolutionizing industries 
              through innovative technology solutions. Founded in 2022 and headquartered in Ongole, Andhra&nbsp;Pradesh, 
              we specialize in transforming complex challenges into intelligent opportunities.
            </p>
          </div>
        </section>

        {/* Our Philosophy */}
        <section className="vero-about__section">
          <div className="vero-about__philosophy">
            <div className="vero-about__philosophy-item">
              <FaBullseye className="vero-about__philosophy-icon" />
              <h3>Our Mission</h3>
              <p>
                To democratize advanced technology and make innovative solutions accessible to businesses 
                and communities, driving sustainable growth and positive societal impact.
              </p>
            </div>
            
            <div className="vero-about__philosophy-item">
              <FaLightbulb className="vero-about__philosophy-icon" />
              <h3>Our Vision</h3>
              <p>
                To become a global leader in AI and data-driven solutions, creating a future where technology 
                seamlessly enhances human potential and environmental sustainability.
              </p>
            </div>
            
            <div className="vero-about__philosophy-item">
              <FaUsers className="vero-about__philosophy-icon" />
              <h3>Our Values</h3>
              <p>
                Innovation, integrity, collaboration, and sustainability form the foundation of everything we do. 
                We believe in building solutions that matter.
              </p>
            </div>
          </div>
        </section>

        {/* Core Expertise */}
        <section className="vero-about__section vero-about__section--highlight">
          <h2 className="vero-about__section-title">Our Core Expertise</h2>
          <p className="vero-about__section-subtitle">
            We combine cutting-edge technology with deep domain knowledge to deliver impactful solutions
          </p>
          
          <div className="vero-about__expertise-grid">
            <div className="vero-about__expertise-card">
              <div className="vero-about__expertise-icon">
                <FaChartLine />
              </div>
              <h3>AI & Data Science</h3>
              <p>
                Building intelligent systems and predictive models that transform raw data into actionable 
                insights across various industries.
              </p>
            </div>
            
            <div className="vero-about__expertise-card">
              <div className="vero-about__expertise-icon">
                <FaMobileAlt />
              </div>
              <h3>Mobile Development</h3>
              <p>
                Creating robust Android applications with user-centric designs for Agriculture, Education, 
                and emerging technology sectors.
              </p>
            </div>
            
            <div className="vero-about__expertise-card">
              <div className="vero-about__expertise-icon">
                <FaGraduationCap />
              </div>
              <h3>Talent Development</h3>
              <p>
                Nurturing next-generation talent in data engineering, machine learning, AI, and emerging 
                technologies through comprehensive training programs.
              </p>
            </div>
            
            <div className="vero-about__expertise-card">
              <div className="vero-about__expertise-icon">
                <FaSeedling />
              </div>
              <h3>Sustainable Tech</h3>
              <p>
                Developing solutions for Agriculture, Green Energy, Environmental Tech, and Waste Management 
                to promote ecological sustainability.
              </p>
            </div>
          </div>
        </section>

        {/* Industry Focus */}
        <section className="vero-about__section">
          <h2 className="vero-about__section-title">Industry Focus Areas</h2>
          <div className="vero-about__industry-focus">
            <div className="vero-about__industry-item">
              <h3>🌾 Agriculture & Food Tech</h3>
              <p>Smart farming solutions, crop monitoring systems, and sustainable food production technologies</p>
            </div>
            
            <div className="vero-about__industry-item">
              <h3>🎓 Education Technology</h3>
              <p>AI-powered learning platforms, educational apps, and digital learning solutions</p>
            </div>
            
            <div className="vero-about__industry-item">
              <h3>♻️ Environmental Tech</h3>
              <p>Waste management solutions, green energy systems, and environmental monitoring tools</p>
            </div>
            
            <div className="vero-about__industry-item">
              <h3>🏥 Healthcare & Wellness</h3>
              <p>AI diagnostics, health monitoring systems, and wellness applications</p>
            </div>
          </div>
        </section>

        {/* What Sets Us Apart */}
        <section className="vero-about__section vero-about__section--dark">
          <h2 className="vero-about__section-title">Why Choose Vero Disruptors?</h2>
          <div className="vero-about__differentiators">
            <div className="vero-about__differentiator">
              <div className="vero-about__differentiator-number">01</div>
              <h3>Innovation-Driven Approach</h3>
              <p>We constantly explore emerging technologies to stay ahead of industry trends and deliver future-proof solutions.</p>
            </div>
            
            <div className="vero-about__differentiator">
              <div className="vero-about__differentiator-number">02</div>
              <h3>Domain Specialization</h3>
              <p>Deep expertise in Agriculture, Education, and Environmental tech ensures relevant and impactful solutions.</p>
            </div>
            
            <div className="vero-about__differentiator">
              <div className="vero-about__differentiator-number">03</div>
              <h3>Talent Ecosystem</h3>
              <p>We bridge the talent gap by developing skilled professionals and connecting them with innovative organizations.</p>
            </div>
            
            <div className="vero-about__differentiator">
              <div className="vero-about__differentiator-number">04</div>
              <h3>Sustainability Focus</h3>
              <p>Every solution is designed with environmental responsibility and long-term sustainability in mind.</p>
            </div>
          </div>
        </section>

        {/* Our Team & Culture */}
        <section className="vero-about__section">
          <h2 className="vero-about__section-title">Our Team & Culture</h2>
          <div className="vero-about__team-culture">
            <div className="vero-about__culture-text">
              <p>
                With a team of 2-10 passionate professionals and 6 associated members on LinkedIn, 
                we foster a culture of continuous learning, innovation, and collaboration.
              </p>
              <p>
                Our team comprises experts in AI, Android Development, data science, software development, and domain-specific 
                knowledge who work together to create meaningful impact.
              </p>
            </div>
            <div className="vero-about__culture-stats">
              <div className="vero-about__stat">
                <span className="vero-about__stat-number">2022</span>
                <span className="vero-about__stat-label">Founded</span>
              </div>
              <div className="vero-about__stat">
                <span className="vero-about__stat-number">6+</span>
                <span className="vero-about__stat-label">Team Members</span>
              </div>
              <div className="vero-about__stat">
                <span className="vero-about__stat-number">4+</span>
                <span className="vero-about__stat-label">Domains</span>
              </div>
              <div className="vero-about__stat">
                <span className="vero-about__stat-number">100%</span>
                <span className="vero-about__stat-label">Dedicated</span>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="vero-about__cta">
          <h2>Ready to Innovate Together?</h2>
          <p>
            Whether you're looking for cutting-edge technology solutions, need skilled talent, 
            or want to explore partnership opportunities, we're here to help transform your vision into reality.
          </p>
          <div className="vero-about__cta-buttons">
            <a href="/contactus" className="vero-about__cta-btn vero-about__cta-btn--primary">
              Get in Touch
            </a>
            <a href="/services" className="vero-about__cta-btn vero-about__cta-btn--secondary">
              Explore Services
            </a>
          </div>
        </section>

        
      </div>
      
    </div>
  );
};

export default About;